module.exports = __webpack_public_path__ + "static/media/analytics.a8a3ff56.png";